import React from 'react';
import { Button, ButtonProps, CircularProgress } from '@mui/material';
import LotusLoader from './LotusLoader';

export interface LoadingButtonProps extends ButtonProps {
  /** Loading state */
  loading?: boolean;
  /** Custom loading indicator (uses LotusLoader by default) */
  loadingIndicator?: React.ReactNode;
  /** Text to show while loading (optional, replaces children) */
  loadingText?: string;
}

/**
 * LoadingButton Component
 * 
 * A button component with built-in loading state support.
 * Shows a lotus loader when loading is true.
 * 
 * @example
 * <LoadingButton loading={submitting} onClick={handleSubmit}>
 *   บันทึก
 * </LoadingButton>
 */
const LoadingButton: React.FC<LoadingButtonProps> = ({
  loading = false,
  loadingIndicator,
  loadingText,
  children,
  disabled,
  ...props
}) => {
  const isDisabled = disabled || loading;

  return (
    <Button
      {...props}
      disabled={isDisabled}
      sx={{
        minWidth: loading ? 'auto' : undefined,
        ...props.sx,
      }}
    >
      {loading ? (
        loadingIndicator || (
          <>
            <LotusLoader size="small" variant="spin" />
            {loadingText && (
              <span style={{ marginLeft: '8px' }}>{loadingText}</span>
            )}
          </>
        )
      ) : (
        children
      )}
    </Button>
  );
};

export default LoadingButton;
